module.exports = __webpack_public_path__ + "img/2(6)-340x379.95e27e6d.png";